var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isLoading
    ? _c(
        "div",
        {
          staticClass: "d-flex align-items-center justify-content-center",
          staticStyle: { height: "400px" }
        },
        [_vm._m(0)]
      )
    : _c(
        "div",
        { staticClass: "row form-page-detail--body" },
        [
          _c("b-col", { attrs: { cols: "12" } }, [
            _c(
              "div",
              { staticClass: "section-container" },
              [
                _c("h6", { staticClass: "font-weight-bold" }, [
                  _vm._v("Model")
                ]),
                _vm._v(" "),
                _vm._l(_vm.dataModel, function(item, index) {
                  return _c(
                    "b-row",
                    { key: index, staticClass: "content-model-ai" },
                    [
                      _c(
                        "b-col",
                        { attrs: { md: "1" } },
                        [
                          _c("b-img", {
                            staticClass: "m-1 round-bordered-img img-circle",
                            attrs: {
                              src: require("@/assets/icon/model-default.png"),
                              rounded: "circle",
                              alt: "img"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { staticClass: "border-bottom", attrs: { md: "9" } },
                        [
                          _c("div", { staticClass: "label-1" }, [
                            _vm._v("Jojonomic")
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "label-2" }, [
                            _vm._v(_vm._s(item.model_name))
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "label-3" },
                            [
                              _c("b-img", {
                                attrs: {
                                  src: require("@/assets/icon/ai-id.png")
                                }
                              }),
                              _vm._v(
                                "\n            " +
                                  _vm._s(item.id) +
                                  "\n            "
                              ),
                              _c("span", { staticClass: "m__l--10" }, [
                                _vm._v(_vm._s(_vm.getDuration(item.updated_at)))
                              ])
                            ],
                            1
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { staticClass: "border-bottom", attrs: { md: "2" } },
                        [
                          _c("div", { staticClass: "label-status" }, [
                            _vm._v(_vm._s(item.status.toUpperCase()))
                          ])
                        ]
                      )
                    ],
                    1
                  )
                })
              ],
              2
            )
          ])
        ],
        1
      )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "lds-ellipsis" }, [
      _c("div"),
      _c("div"),
      _c("div"),
      _c("div")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fb748cba", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fb748cba","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ai/menu/jMenuModel.vue
// module id = null
// module chunks = 